/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConsumerBatch } from './ConsumerBatch';
import {
    ConsumerBatchFromJSON,
    ConsumerBatchFromJSONTyped,
    ConsumerBatchToJSON,
    ConsumerBatchToJSONTyped,
} from './ConsumerBatch';
import type { ConsumerWebhook } from './ConsumerWebhook';
import {
    ConsumerWebhookFromJSON,
    ConsumerWebhookFromJSONTyped,
    ConsumerWebhookToJSON,
    ConsumerWebhookToJSONTyped,
} from './ConsumerWebhook';
import type { ConsumerProtocol } from './ConsumerProtocol';
import {
    ConsumerProtocolFromJSON,
    ConsumerProtocolFromJSONTyped,
    ConsumerProtocolToJSON,
    ConsumerProtocolToJSONTyped,
} from './ConsumerProtocol';

/**
 * Request body for creating a new consumer.
 * @export
 * @interface ConsumerCreateRequest
 */
export interface ConsumerCreateRequest {
    /**
     * Display name of the consumer.
     * @type {string}
     * @memberof ConsumerCreateRequest
     */
    name: string;
    /**
     * 
     * @type {ConsumerProtocol}
     * @memberof ConsumerCreateRequest
     */
    protocol: ConsumerProtocol;
    /**
     * Whether to include the full Logistics Object body in notifications.
     * 
     * This setting only applies to subscriptions with `notificationType: EVENTS`:
     * - When `true`, the notification includes both the event and the LO body.
     * - When `false` (default), only the event is included.
     * 
     * For `UPDATES` and `ACL` subscriptions, this setting is ignored; the LO is always included.
     * 
     * When enabled, the LO is fetched via the admin API (e.g., `GET /admin/{resource-type}/{id}`).
     * 
     * @type {boolean}
     * @memberof ConsumerCreateRequest
     */
    includeLo?: boolean;
    /**
     * 
     * @type {ConsumerBatch}
     * @memberof ConsumerCreateRequest
     */
    batch?: ConsumerBatch;
    /**
     * 
     * @type {ConsumerWebhook}
     * @memberof ConsumerCreateRequest
     */
    webhook?: ConsumerWebhook;
}



/**
 * Check if a given object implements the ConsumerCreateRequest interface.
 */
export function instanceOfConsumerCreateRequest(value: object): value is ConsumerCreateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('protocol' in value) || value['protocol'] === undefined) return false;
    return true;
}

export function ConsumerCreateRequestFromJSON(json: any): ConsumerCreateRequest {
    return ConsumerCreateRequestFromJSONTyped(json, false);
}

export function ConsumerCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConsumerCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'protocol': ConsumerProtocolFromJSON(json['protocol']),
        'includeLo': json['includeLo'] == null ? undefined : json['includeLo'],
        'batch': json['batch'] == null ? undefined : ConsumerBatchFromJSON(json['batch']),
        'webhook': json['webhook'] == null ? undefined : ConsumerWebhookFromJSON(json['webhook']),
    };
}

export function ConsumerCreateRequestToJSON(json: any): ConsumerCreateRequest {
    return ConsumerCreateRequestToJSONTyped(json, false);
}

export function ConsumerCreateRequestToJSONTyped(value?: ConsumerCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'protocol': ConsumerProtocolToJSON(value['protocol']),
        'includeLo': value['includeLo'],
        'batch': ConsumerBatchToJSON(value['batch']),
        'webhook': ConsumerWebhookToJSON(value['webhook']),
    };
}

